/**
 * Settings → Auto mail → Manual handle. One template per event, sent when a
 * manual-handle ticket is created, approved or dropped. The words a template
 * can use are {{key}}; an unknown key stays as written.
 */
export const MANUAL_MAIL_EVENTS = ['created', 'approved', 'dropped'];
export const SUPPORT_MANUAL_MAIL_PLACEHOLDERS = [
    { key: 'ticket_number', label: 'Ticket number' },
    { key: 'ticket_subject', label: 'Subject' },
    { key: 'ticket_summary', label: 'Summary' },
    { key: 'ticket_link', label: 'Ticket link' },
    { key: 'priority', label: 'Priority' },
    { key: 'customer_name', label: 'Customer' },
    { key: 'project_name', label: 'Project' },
    { key: 'contract_id', label: 'Contract ID' },
    { key: 'contract_type', label: 'Contract type' },
    { key: 'account_manager', label: 'Account manager' },
    { key: 'account_manager_email', label: 'Account manager email' },
    { key: 'drop_reason', label: 'Drop reason' },
    { key: 'decided_by', label: 'Decided by' },
];
export const MANUAL_MAIL_EVENT_LABELS = {
    created: 'Created',
    approved: 'Approved',
    dropped: 'Dropped',
};
/** Kind filter for the shared Sent log (reminders, manual-handle and team mails). */
export const SUPPORT_AUTO_MAIL_LOG_FILTERS = [
    { kind: 'reminder', label: 'Contract reminders' },
    { kind: 'manual_created', label: 'Manual handle — created' },
    { kind: 'manual_approved', label: 'Manual handle — approved' },
    { kind: 'manual_dropped', label: 'Manual handle — dropped' },
    { kind: 'team_assigned', label: 'Team reminders — assigned' },
    { kind: 'team_ignored', label: 'Team reminders — ignored' },
    { kind: 'team_digest', label: 'Team reminders — daily digest' },
];
/** Settings → Auto mail → Team reminders. One mail per kind. */
export const TEAM_REMINDER_KINDS = ['assigned', 'ignored', 'digest'];
export const SUPPORT_TEAM_REMINDER_PLACEHOLDERS = [
    { key: 'user_name', label: 'Name' },
    { key: 'ticket_number', label: 'Ticket number' },
    { key: 'ticket_subject', label: 'Subject' },
    { key: 'ticket_link', label: 'Ticket link' },
    { key: 'priority', label: 'Priority' },
    { key: 'stage', label: 'Stage' },
    { key: 'due', label: 'Due' },
    { key: 'minutes_ignored', label: 'Minutes ignored' },
    { key: 'tickets_list', label: 'Ticket list' },
    { key: 'tickets_count', label: 'Ticket count' },
];
/** {{key}} → the value; unknown keys stay as written. An empty value is kept. */
export function fillManualMailPlaceholders(text, vars) {
    return text.replace(/\{\{\s*([a-z_]+)\s*\}\}/g, (whole, key) => {
        if (!Object.prototype.hasOwnProperty.call(vars, key))
            return whole;
        return vars[key] ?? '';
    });
}
//# sourceMappingURL=support-auto-mail.js.map